import { Empty } from 'antd';
import { fieldKindsForType } from './contentModel';
import { FlyerUrlsField } from './fields/FlyerUrlsField';
import { AttachmentsField } from './fields/AttachmentsField';
import { ReferenceField } from './fields/ReferenceField';
import { ScheduleContentField } from './fields/ScheduleContentField';
import type { TopicDetails } from '@/types/topic';

/** Renders the type-specific content-field editor(s) for the topic's type. */
export function ContentFieldsTab({ typeId, details, langs, onChange }: {
  typeId: number;
  details: TopicDetails;
  langs: string[];
  onChange: (d: TopicDetails) => void;
}) {
  const kinds = fieldKindsForType(typeId);
  const p = { details, langs, onChange };
  return (
    <div style={{ display: 'grid', gap: 20 }}>
      {kinds.includes('flyer') && <FlyerUrlsField {...p} />}
      {kinds.includes('attachment') && <AttachmentsField {...p} />}
      {kinds.includes('schedule') && <ScheduleContentField {...p} />}
      {kinds.includes('reference') && <ReferenceField {...p} />}
      {kinds.length === 0 && <Empty description="No type-specific fields" />}
    </div>
  );
}
